import React, { Component } from 'react';
import { Spinner } from 'reactstrap';
import MyResource from '../MyResource.js';
class Loader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lblComDeflaLoad: MyResource.fnLanguageValues('lblComDeflaLoad'),  //Loading...
        };
    }

    componentDidMount() {
    }

    render() {
        var code = this.props.code;
        if (code === undefined || code === null || code === "") {
            code = "info";
        }
        var type = this.props.type;
        if (type === undefined || type === null || type === "") {
            return (
                <>
                    <div style={{ width: '100%' }}>
                        <br />
                        <div className="d-flex justify-content-center"  >
                            <div className={"spinner-border text-" + code} role="status">
                                <span className="sr-only">{this.state.lblComDeflaLoad}</span>
                            </div>
                        </div>
                        <p style={{ textAlign: 'center' }}><strong><br />{this.state.lblComDeflaLoad}</strong></p>
                    </div>
                </>
            );
        }
        else {
            return (
                <i className='fa icon-refresh fa-spin'></i>
            )
        }

    }
}

export default Loader;

